<template>
    <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <!-- Main Nav -->
        <div class="container-fluid px-0">

            <!-- Logo and categories dropdown -->
            <div class="d-flex align-items-center" :class="{ 'w-25': width > 1399 }">

                <router-link to="/" class="navbar-brand fw-semi-bold fs-4 py-0 specific-style">
                    ExploreMeds
                </router-link>

                <!-- Categories dropdown -->
                <ul class="navbar-nav me-auto mb-2 mb-md-0">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle fw-medium specific-style bg-hover-gray rounded-pill" href="#"
                            role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                            All
                            Categories </a>
                        <ul class="dropdown-menu">
                            <li v-for="category in categories">
                                <a v-load-page="category.route" v-ripple class="dropdown-item cursor-pointer">
                                    <i class="me-3" :class="category.iconClass"></i>
                                    {{ category.label }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>

            <!-- Search -->
            <div :class="width > 1399 ? 'w-45' : 'w-100 mx-4'">
                <Search v-if="route.name != 'home'" class="glass-effect"></Search>
            </div>

            <!-- Profile dropdown -->
            <div class="d-flex justify-content-end" :class="{ 'w-25': width > 1399 }">
                <div class="dropdown" :class="route.name == 'home' ? 'ms-auto' : ''">
                    <!-- Dropdown toggler -->
                    <img class="rounded-circle avatar cursor-pointer dropdown-toggle specific-style"
                        :data-bs-toggle="'dropdown'" data-bs-auto-close="outside"
                        :src="userLoggedIn ? randomAvatar : profilePic"
                        :style="userLoggedIn ? `background-color: ${randomBgColor};` : false" />

                    <ul class="dropdown-menu dropdown-menu-end overflow-hidden">
                        <template v-if="!userLoggedIn">
	                        <li>
		                        <a v-load-page="'/survey/anonymous'" v-ripple class="dropdown-item cursor-pointer">
			                        <i class="me-3 bi-list-ul"></i> Start Survey
		                        </a>
	                        </li>
                            <li>
                                <a v-load-page="'/login'" v-ripple class="dropdown-item cursor-pointer">
                                    <i class="me-3 bi-box-arrow-in-right"></i> Log In
                                </a>
                            </li>
                            <li>
                                <a v-load-page="'/register'" v-ripple class="dropdown-item cursor-pointer">
                                    <i class="me-3 bi-person-add"></i> Register
                                </a>
                            </li>
                        </template>
                        <template v-else>
                            <!-- Profile item -->
                            <li>
                                <a class="dropdown-item py-2 cursor-unset" href="#">
                                    <img class="rounded-circle avatar me-3"
                                        :src="userLoggedIn ? randomAvatar : profilePic"
                                        :style="userLoggedIn ? `background-color: ${randomBgColor};` : false" />
                                    <div class="d-flex flex-column">
                                        <p class="m-0 mb-2 fs-5 fw-medium lh-1">{{ authStore.user.username }}</p>
                                        <p class="m-0 lh-1 caption">My Profile</p>
                                    </div>
                                </a>
                            </li>
                            <!-- Options -->
                            <li>
                                <hr class="dropdown-divider">
                            </li>

                            <li v-for="item in profileDropdownItems">
                                <hr v-if="item.hasOwnProperty('isDivider')" class="dropdown-divider">
                                <a v-else-if="item.route != '/logout' && (!item.hasOwnProperty('userTypes') || (item.hasOwnProperty('userTypes') && item.userTypes.includes(user_type)))"
                                    v-load-page="item.route" v-ripple class="dropdown-item cursor-pointer">
                                    <i class="me-3" :class="item.iconClass"></i>
                                    {{ item.label }}
                                    <i class="ms-auto" :class="item.iconRightClass"
                                        v-if="item.hasOwnProperty('iconRightClass')"></i>
                                </a>
                                <a v-else-if="item.route == '/logout'" v-load-page="item.route" @click.prevent="authStore.performLogout()" v-ripple
                                    class="dropdown-item cursor-pointer">
                                    <i class="me-3" :class="item.iconClass"></i>
                                    {{ item.label }}
                                    <i class="ms-auto" :class="item.iconRightClass"
                                        v-if="item.hasOwnProperty('iconRightClass')"></i>
                                </a>
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import { useWindowSize } from '@vueuse/core'
import { useRoute } from 'vue-router';
import { categories, profileDropdownItems } from './navitems.js';
import profilePic from '../../assets/user.png';
import Search from '../Search/Index.vue';
import { useAuthStore } from "@/stores/auth-store"

const route = useRoute();
const { width } = useWindowSize();

const authStore = useAuthStore();
// const isLoggedIn = ref(authStore.isLoggedIn);
// watch(() => authStore.isLoggedIn, (newVal, oldVal) => {
//     isLoggedIn.value = authStore.isLoggedIn;
// });

const userLoggedIn = computed(() => {
    return authStore.isLoggedIn;
});

const user_type = computed(() => {
    return authStore.getUserType;
});

const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const generateRandomString = (length) => {
    let result = ' ';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}
const bgColors = ['#264653', '#2a9d8f', '#e9c46a', '#f4a261', '#f4a261', '#e76f51'];
const randomBgColor = ref(bgColors[Math.floor(Math.random() * bgColors.length)]);
const randomAvatar = ref('https://anonymous-animals.azurewebsites.net/avatar/' + generateRandomString(5));

</script>

<style scoped lang="scss">
.bg-hover-gray {
    padding: 0.65em 1em !important;

    &:hover {
        background-color: #f5f5f7;
    }

    &:active {
        background-color: #d4d4d5;
    }

}
</style>